
/*运行管理系统*/

/*主容器文件*/
const yxzc_ = () =>  import("../../../studio/sub_systems/yxzcxt/yxzc_system_main");

/*运行支撑系统  首页子系统*/
const yxzc_index_ = () =>  import("../../../studio/sub_systems/yxzcxt/index_page/index_page_main");
/*运行支撑系统  首页子系统 - 数据字典*/
const yxzc_index_sjzd = () =>  import("../../../studio/sub_systems/yxzcxt/index_page/zdgl/zdgl_main");
// 农资字典管理
const nzywsjgl_gylglzxt_dictionary = () =>  import("../../../studio/sub_systems/nzywsjgl_systems/gylglzxt/dictionary/productType/productType.vue");
/*运行支撑系统  首页子系统 - 机构管理*/
const yxzc_index_deptManager = () =>  import("../../../studio/sub_systems/yxzcxt/index_page/organizationModule/main.vue");
/*运行支撑系统  首页子系统 - 菜单管理*/
const yxzc_index_menuManager = () =>  import("../../../studio/sub_systems/yxzcxt/index_page/menuManager/main.vue");
/*运行支撑系统  首页子系统 - 用户管理*/
const yxzc_index_userControl = () =>  import("../../../studio/sub_systems/yxzcxt/index_page/userControl/main.vue");
/*运行支撑系统  首页子系统 - 用户管理*/
const yxzc_index_groupControl = () =>  import("../../../studio/sub_systems/yxzcxt/index_page/groupControl/main.vue");
/*运行支撑系统  首页子系统 - 角色管理*/
const yxzc_index_roleManager = () =>  import("../../../studio/sub_systems/yxzcxt/index_page/roleManager/main.vue");
/*运行支撑系统  首页子系统 - 操控日志*/
const yxzc_index_logManagement = () =>  import("../../../studio/sub_systems/yxzcxt/index_page/logManagement/main.vue");
/*运行支撑系统  首页子系统 - 系统监控*/
const yxzc_index_systemMonitoring = () =>  import("../../../studio/sub_systems/yxzcxt/index_page/systemMonitoring/main.vue");
/*运行支撑系统  首页子系统 - 驾驶舱数据录入*/
const yxzc_index_cockpitInput = () =>  import("../../../studio/sub_systems/yxzcxt/index_page/cockpitInput/navigationPage.vue");

export default [
  {
    path: '/yxzcxt',
    name: '运行支撑系统',
    redirect: '/yxzcxt/index',
    component: yxzc_,
    children: [
      {
        path: '/yxzcxt/index',
        redirect: '/yxzcxt/index/sjzd',
        name: '首页',
        component: yxzc_index_,
        children:[
          {
            path: '/yxzcxt/index/deptManager',
            name: '机构管理',
            component: yxzc_index_deptManager ,
          },
          {
            path: '/yxzcxt/index/userControl',
            name: '公司人员管理',
            component: yxzc_index_userControl ,
          },
          {
            path: '/yxzcxt/index/groupControl',
            name: '公司人员管理',
            component: yxzc_index_groupControl ,
          },
          {
            path: '/yxzcxt/index/roleManager',
            name: '角色管理',
            component: yxzc_index_roleManager ,
          },
          {
            path: '/yxzcxt/index/menuManager',
            name: '菜单管理',
            component: yxzc_index_menuManager ,
          },
          {
            path: '/yxzcxt/index/logManagement',
            name: '操控日志',
            component: yxzc_index_logManagement ,
          },
          {
            path: '/yxzcxt/index/systemMonitoring',
            name: '系统监控',
            component: yxzc_index_systemMonitoring ,
          },
          {
            path: '/yxzcxt/index/cockpitInput',
            name: '驾驶舱数据录入',
            component: yxzc_index_cockpitInput ,
          },
          {
            path: '/yxzcxt/index/sjzd',
            name: '通用数据字典',
            component: yxzc_index_sjzd ,
          },
          {
            path: '/yxzcxt/gylglzxt/dictionary',
            name: '农资字典管理',
            component: nzywsjgl_gylglzxt_dictionary ,
          },
        ]
      },

    ]
  },

]



// WEBPACK FOOTER //
// ./src/router/modules/yxzcxt/yxzc_system_page.js